export const BASE_URL =
  process.env.REACT_APP_BASE_URL || 'https://sunni-waqf-api.byklabs.com/api/';
export const Image_URL =
  process.env.REACT_APP_IMAGE_URL ||
  'https://klabs-testing-ap-south-1.s3.ap-south-1.amazonaws.com/sunni-waqf/';
